import { render, staticRenderFns } from "./ProjectsTreeView.vue?vue&type=template&id=33f20a8f&scoped=true"
import script from "./ProjectsTreeView.vue?vue&type=script&lang=js"
export * from "./ProjectsTreeView.vue?vue&type=script&lang=js"
import style0 from "./ProjectsTreeView.vue?vue&type=style&index=0&id=33f20a8f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f20a8f",
  null
  
)

export default component.exports